export const ROSTER_REQUESTS_SELF_MATCH =
  'secure/users/{username}/roster/requests/self-match';
export const API_ACCOUNTS =
  'secure/{username}/administration/maintenance/api-accounts';
export const COST_CENTERS_ROSTER_CYCLE =
  'secure/users/{username}/cost-centers/:costCenterId/roster-cycle';
export const EMPLOYEES_QUALIFICATIONS =
  'secure/users/{username}/employees/:employeeId/qualifications';
export const EMPLOYEE_QUALIFICATION =
  'secure/users/{username}/employees/:employeeId/qualifications/:qualificationId';
export const EMPLOYER =
  'secure/{username}/administration/maintenance/employers';
export const QUALIFICATIONS = 'secure/users/{username}/qualifications';
export const ROSTER_QUALIFICATIONS =
  'secure/users/{username}/roster/qualification/types';
export const PREFERRED_ROSTER_QUALIFICATIONS =
  'secure/users/{username}/cost-centers/:costCenterId/qualifications';
export const EMBEDDED_DASHBOARD = 'secure/users/{username}/embedded-analytics';
export const ACCOUNT_TRIALS = 'secure/users/{username}/trials';
export const TEAM_ROSTER = 'secure/users/{username}/team-roster';
export const SELF_MATCH_DUTIES = 'secure/self-match/duties/:requestId/:type';
export const PUBLIC_HOLIDAYS = 'secure/public/holidays';
export const SPECIALS_HOLIDAYS =
  'secure/{username}/administration/maintenance/holidays-special';
export const EMPLOYEES_WORK_AGREEMENTS =
  'secure/users/{username}/employees/:employeeId/work-agreements';
export const EMPLOYEES_WORK_AGREEMENT_DETAILS =
  'secure/users/{username}/employees/:employeeId/work-agreements-details';
export const QUALITY_MONITOR = 'secure/users/{username}/quality-monitor';
export const WORK_PATTERNS = 'secure/users/{username}/work-patterns';
export const EMPLOYEES_WORK_PATTERNS =
  'secure/users/{username}/employees/:employeeId/work-patterns';
export const COST_CENTER_PUBLICATION =
  'secure/users/{username}/cost-center/publication';
export const WORK_AGREEMENTS_BALANCE_BUDGET =
  'secure/users/{username}/work-agreements/:workAgreementId/balance-budget/overview';
export const WORK_AGREEMENTS_BALANCE_BUDGET_TRANSACTIONS =
  'secure/users/{username}/work-agreements/:workAgreementId/balance-budget/transactions';
export const COSTCENTERS = 'secure/users/{username}/cost-centers';
export const EMPLOYEE_COSTCENTERS =
  'secure/users/{username}/cost-centers/employee';
export const PUBLIC_COSTCENTERS = 'secure/public/costcenters';
export const PLAN_GROUPS = 'secure/users/{username}/plan-groups';
export const USER_PREFERENCE = 'secure/users/{username}/preference';
export const ROSTER_REQUESTS_MATCH_ACTIONS =
  'secure/users/{username}/roster/requests/match-actions';
export const CONTACTS = 'secure/contacts';
export const USERS_EMPLOYEES = 'secure/users/{username}/employees';
export const EMPLOYEES = 'secure/employees';
export const EMPLOYEES_WITH_USERNAME = '/secure/users/{username}/employees';
export const ROSTER_FUNCTIONS = 'secure/users/{username}/roster/functions';
export const COST_CENTERS_FUNCTIONS =
  'secure/users/{username}/cost-centers/:costCenterId/functions';
export const ROSTER_DUTY_HOUR_TYPES =
  'secure/users/{username}/roster/cost-centers/duty-hour-types';
export const CAPACITY = 'secure/capacity-plan/scenario/:scenarioId/capacity';
export const CAPACITY_BALANCE =
  'secure/capacity-plan/scenario/:scenarioId/capacity-balance';
export const SCENARIO = 'secure/users/{username}/capacity-plan/scenario';
export const SCENARIO_OVERVIEW_WORK_DEMAND =
  'secure/capacity-plan/scenario/:scenarioId/overview/work-demand';
export const SCENARIO_OVERVIEW_BASEPLAN =
  'secure/capacity-plan/scenario/:scenarioId/overview/baseplan';
export const SCENARIO_OVERVIEW_FORMATION =
  'secure/capacity-plan/scenario/:scenarioId/overview/formation';
export const SCENARIO_OVERVIEW_ROSTER =
  'secure/capacity-plan/scenario/:scenarioId/overview/roster';
export const SCENARIO_EMPLOYMENT_SETTINGS =
  'secure/capacity-plan/scenario/:scenarioId/employment-settings';
export const SCENARIO_ADDITIONAL_CAPACITY =
  'secure/capacity-plan/scenarios/:scenarioId/additional-capacity';
export const SCENARIO_EMPLOYER_SETTINGS =
  'secure/users/{username}/capacity-plan/scenario/:scenarioId/settings/employer/:year';
export const SCENARIO_FLEX_CAPACITY_SETTINGS =
  'secure/capacity-plan/scenarios/:scenarioId/flex-capacity-settings/:year';
export const ORGANIZATIONAL_UNIT_DISTRIBUTIONS =
  'secure/employments/:employmentId/organizational-unit-distributions';
export const EMPLOYEES_CLAS = 'secure/users/{username}/employees/clas';
export const WORK_DEMAND =
  'secure/users/{username}/capacity-plan/scenario/:scenarioId/care-demand';
export const WORK_DEMAND_CALCULATED =
  'secure/capacity-plan/scenario/:scenarioId/work-demand';
export const ROSTER_BASEPLAN = 'secure/users/{username}/roster/baseplans';
export const SCENARIO_PLANNED_HOURS_GET =
  'secure/capacity-plan/scenario/:scenarioId/baseplan-link';
export const SCENARIO_PLANNED_HOURS =
  'secure/users/{username}/capacity-plan/scenario/:scenarioId/baseplan-link';
export const SCENARIO_NON_PLANNED_HOURS =
  'secure/users/{username}/capacity-plan/scenario/:scenarioId/non-planned';
export const SCENARIO_NON_PLANNED_HOURS_GET =
  'secure/capacity-plan/scenario/:scenarioId/non-planned';
export const SCENARIO_CAPACITY_SETTINGS =
  'secure/capacity-plan/scenarios/:scenarioId/capacity-settings/:year';
export const SURCHARGE_RELATIONS =
  '/secure/{user}/administration/maintenance/br-employer-link-client';
export const PREFERRED_FUNCTIONS =
  'secure/users/{username}/roster/functions/preferred';
export const SURCHARGES =
  '/secure/{username}/administration/maintenance/surcharges';
export const CALENDAR = 'secure/calendar';
export const SYS_ADMIN_SYNC = `/secure/{username}/administration/maintenance/identity-sync`;
export const ADDITIONAL_CAPACITY = 'secure/capacity/additional-capacity';
export const ADDITIONAL_CAPACITY_OVERVIEW =
  'secure/capacity/additional-capacity-overview';
export const CAPACITY_PLAN_REPORT =
  'secure/capacity-plan/scenario/:scenarioId/overview/report';
export const IMPORT_QUEUE = 'secure/sdb-import-queue';
export const DATA_QUEUE = 'secure/data-queue';
export const SCHEDULING_QUEUE = 'secure/scheduling-queue';
export const REPORT_QUEUE = 'secure/report-queue';
export const LAST_LOCKED_MONTH = 'secure/public/last-locked-month';
export const CRON_JOBS = 'secure/admin/{username}/cron-jobs';
export const CRON_JOB_DEFINITIONS =
  'secure/admin/{username}/cron-jobs/definitions';
export const IMPORT_DEFINITIONS = 'secure/admin/{username}/import/definitions';
export const CALCULATE_DUTY_LINES =
  'secure/admin/{username}/calculate/dutylines';
export const CALCULATE_DUTY_LINES_EMPLOYEE =
  'secure/admin/{username}/calculate/employee/:employeeId/dutylines';
export const REALIZATION = 'secure/admin/{username}/dutyline/realize';
export const APPROVE_DUTY_LINES = 'secure/admin/{username}/dutyline/approve';
export const DUTY_LINES_SUMMARY = 'secure/admin/duties-realization-summary';
export const GENERATE_REALIZATION_REPORT =
  'secure/users/{username}/reports/basic/duty_report_compact';
export const RECALCULATE_HOUR_MANAGEMENT =
  'secure/admin/{username}/hours-management/calculate';

export const EMPLOYMENT_HOURS =
  'secure/users/{username}/employees/:employeeId/work-agreements/:workAgreementId/hours';
export const EMPLOYMENT_CLA_YEAR =
  'secure/users/{username}/employees/:employeeId/work-agreements/:workAgreementId/cla-year';
export const EMPLOYMENT_HOURS_CORRECTION = `${EMPLOYMENT_HOURS}/:dutyLineMngId`;
export const ABSENCES = 'secure/absences';
export const CLIENT_ABSENCES = 'secure/clients/:clientId/absences';
export const UPDATE_CLIENT_ABSENCE =
  'secure/clients/:clientId/absences/:clientAbsenceId';
export const GET_CLIENT_ABSENCE_REASONS = 'secure/client-absence-reasons';
export const END_CLIENT_ABSENCE_PERIOD =
  'secure/clients/:clientId/absences/:clientAbsenceId/end';
export const DELETE_CLIENT_ABSENCE_PERIOD =
  'secure/clients/:clientId/absences/:clientAbsenceId';
export const DUTY_LINES =
  'secure/users/{username}/employees/:employeeId/duty-lines';
export const GENERATED_REPORTS = 'secure/reports/generated';
export const GENERATED_REPORT_DOWNLOAD =
  'secure/reports/generated/:reportId/download';
export const ADMIN_SETTINGS_GROUP =
  'secure/{username}/administration/maintenance/settingsgroup';
export const COSTCENTER_SETTINGS_GROUP =
  'secure/{username}/administration/maintenance/costcenter-settingsgroup';
export const COSTCENTER_DETAILS =
  'secure/users/{username}/cost-centers/:costCenterId?referenceDate=:referenceDate';
export const COSTCENTER_ROSTER_STATE_SETTINGS =
  'secure/users/{username}/cost-centers/:costCenterId/roster-state-settings';
export const ADMIN_CLA_SETTINGS =
  'secure/{username}/administration/maintenance/cla-date';
export const CLA_YEAR_SETTINGS =
  'secure/{username}/administration/maintenance/claYears';
export const BR_TYPES = 'secure/users/{user}/group/br-type';
export const BR_CATEGORIES = 'secure/users/{user}/group/br-category';
export const EMPLOYERS =
  'secure/{username}/administration/maintenance/employers';
export const PLAN_UNIT_DETAILS =
  'secure/{username}/administration/maintenance/costcenterdetails';
export const DISTANCES =
  'secure/{username}/administration/maintenance/distances';
export const DUTY_CODES = 'secure/{username}/administration/maintenance/duties';
export const DUTY_LINES_OVERVIEW =
  'secure/users/{username}/employees/:employeeId/duty-lines?startDate=:startDate&endDate=:endDate&showUnpublished=:showUnpublished';
export const DUTY_PERIODS =
  'secure/{username}/administration/maintenance/dutyperiods';
export const HOLIDAYS = 'secure/{username}/administration/maintenance/holidays';
export const HOLIDAY_HOURS =
  'secure/{username}/administration/maintenance/auxperiod';
export const PERIOD_TYPES = '/secure/users/{username}/group/period-type';
export const VAT_OPTIONS = '/secure/users/{username}/group/vat';
export const SERVICE_BR_OPTIONS = '/secure/users/{username}/cost-centers';
export const AGE_HOURS = 'secure/{username}/administration/maintenance/agelist';
export const PLAN_UNITS =
  'secure/{username}/administration/maintenance/costcenters';
export const BUH_HANDLINGS = '/secure/users/{username}/group/buh-handling';
export const SURCHARGES_MAINTENANCE =
  'secure/{username}/administration/maintenance/surcharges';
export const DHT_CLA_SETTINGS =
  'secure/{username}/administration/maintenance/duty-hour-type-dyn-cla';
export const EMPLOYER_COST_SETTINGS =
  'secure/{username}/administration/maintenance/employersettings';
export const GENERATE_SALARY_COMPONENTS =
  'secure/users/{username}/administration/duty-hour-type-dyn-cla/generate';
export const SALARY_SCALES =
  '/secure/{username}/administration/maintenance/salaryscales';
export const DAY_LIMIT_ARRANGEMENTS = 'secure/day-limit-arrangements';
export const CLA_OPTIONS = '/secure/{username}/administration/maintenance/cla';
export const CLUSTERS =
  '/secure/{username}/administration/maintenance/clusters';
export const CLUSTERS_LINKED =
  '/secure/{username}/administration/maintenance/br-link-cluster';
export const MODULES = '/secure/{username}/administration/maintenance/modules';
export const FLEX_HISTORY =
  '/secure/users/{username}/flexportal/processes/history';
export const EMPLOYEE_LIST =
  '/secure/users/{username}/flexportal/employee-list';
export const EMPLOYEE_CARD_MESSAGES = `secure/users/{username}/tasks/:taskId/employeecard?collection=:status`;

export const EMPLOYEE_MESSAGES = `secure/users/{username}/tasks/employee?collection=:status`;
export const EMPLOYEE_MESSAGE_TASK = 'secure/users/{username}/tasks/submitform';
export const REQUEST_REASON = '/secure/users/{username}/group/request-reason';
export const EMPLOYMENT_AGENCIES =
  'secure/users/{username}/cost-centers?type=agn';
export const FLEX_DISCONNECT_REASONS =
  'secure/users/{username}/flexportal/match/disconnect-reasons';
export const FLEX_DUTY_HOUR_TYPES =
  'secure/users/{username}/roster/cost-centers/duty-hour-types';
export const FLEX_DUTY_LINE =
  'secure/users/{username}/flexportal/match/duty-line';
export const EMPLOYEE_NOTES =
  'secure/users/{username}/employees/:employeeId/notes';
export const REMOVE_EMPLOYEE_NOTES = 'secure/users/{username}/notes/:noteId';
export const EMPLOYEE_LEAVE_REQUESTS = 'secure/users/{username}/leave-requests';
export const SORTORDER =
  'secure/users/{username}/cost-centers/:costCenterId/sortorder';
export const REQUEST_NOTES =
  'secure/users/{username}/roster/requests/:requestId/notes';
export const REQUEST_ADD_NOTE =
  'secure/users/{username}/roster/requests/addNote';
export const PUBLIC_DUTY_HOUR_TYPES = 'secure/public/duty-hour-types';
export const TRAVEL_ARRANGEMENTS =
  'secure/users/{username}/employees/:employeeId/travel-arrangements';
export const EMPLOYEE_DETAILS = 'secure/users/{username}/employees/:employeeId';
export const BONUS_PERIODS =
  'secure/users/{username}/employees/:employeeId/bonus-periods?startDate=:startDate&endDate=:endDate&buhTypeSvc=:buhTypeSvc';
export const BONUS_PERIODS_RESTRICTED =
  'secure/users/{username}/employees/:employeeId/bonus-periods-restricted?startDate=:startDate&endDate=:endDate&buhTypeSvc=:buhTypeSvc';
export const BASIC_DUTIES_BASED_ON_COST_CENTER =
  'secure/users/{username}/roster/cost-centers/basic-duties';
export const ROSTER_DUTY_LINE = 'secure/users/{username}/roster/dutyline';
export const FLEX_PORTAL = '/secure/users/{username}/flexportal';
export const REQUEST_PREFERRED_EMPLOYEES =
  '/secure/users/{username}/roster/requests/:requestId/preferred-employees';
export const REQUEST_QUALIFICATIONS =
  '/secure/users/{username}/roster/requests/:requestId/qualifications';
export const TASKS_OUTBOUND =
  'secure/users/{username}/tasks/:askedTaskId/outbound';
export const ROSTER_REQUESTS = '/secure/users/{username}/roster/requests';
export const COST_CENTERS_EMPLOYEES =
  '/secure/users/{username}/cost-centers/employees';
export const ROSTER_PUBLICATION =
  '/secure/users/{username}/cost-center/publication/latest';
export const OPEN_REQUESTS =
  '/secure/users/{username}/roster/cost-centers/open-requests';
export const ROSTER_QUALIFICATIONS_BY_COST_CENTERS =
  '/secure/users/{username}/roster/cost-centers/qualifications';
export const ROSTER_REGISTER_ABSENCE_DUTIES =
  'secure/users/{username}/roster/register-absence/duties';
export const ROSTER_REGISTER_ABSENCE_REASONS =
  'secure/users/{username}/roster/register-absence/reasons';
export const ROSTER_REGISTER_ABSENCE_PROPOSAL =
  'secure/users/{username}/roster/register-absence/proposal';
export const ROSTER_REGISTER_ABSENCE =
  'secure/users/{username}/roster/register-absence';
export const ROSTER_ABSENCE_ROLLOUT =
  'secure/users/{username}/roster/absence/rollout';
export const PUBLIC_DEFAULT_SETTINGS = 'secure/public/default-settings';

// Planning (Activiteiten)
export const APPOINTMENT_GROUPING_PLANNING =
  'secure/appointment-grouping-planning';
export const CREATE_APPOINTMENT = 'secure/appointments';
export const DUTY_LINES_NO_REQUEST =
  'secure/users/{username}/roster/dutyline/no-request';
export const TRAVEL_DISTANCES = 'secure/travel-distances';
export const COUNTRIES = 'secure/public/countries';
export const CONNECT_APPOINTMENTS =
  'secure/appointment-groupings/:appointmentGroupingId/connect';
export const CONNECT_SCHEDULE = 'secure/planning/connect-schedule';
export const UPDATE_ROUTE_START =
  'secure/appointment-groupings/:appointmentGroupingId/update-start';
export const END_APPOINTMENTS = 'secure/appointments/end';
export const VERSION_HISTORY = 'secure/admin/version-history';
export const ADMIN_SETTINGS_FUNCTIONS =
  'secure/{username}/administration/maintenance/functions';
export const ADMIN_SETTINGS_DUTY_HOUR_TYPES =
  'secure/{username}/administration/maintenance/dutyhourtypes';
export const HIERARCHY = 'secure/public/costcenters/hierarchy';
export const ADMIN_SETTINGS_BULK_ADD_CLUSTER =
  'secure/{username}/administration/maintenance/costcenter/bulk-add-cluster';
export const ADMIN_SETTINGS_BULK_UPDATE_EMPLOYER =
  'secure/{username}/administration/maintenance/costcenter/bulk-update-employer';
export const ADMIN_SETTINGS_BULK_UPDATE_POOLS =
  'secure/{username}/administration/maintenance/costcenter/bulk-update-pools';
export const ADMIN_SETTINGS_DUTY_CALCULATION_CODES =
  'secure/{username}/administration/duty-calculation-codes';
export const ADMIN_SETTINGS_MAINTENANCE_DUTY_CALCULATION_CODES =
  'secure/{username}/administration/maintenance/duty-calculation-codes';
export const ADMIN_SETTINGS_DTR_RULES =
  'secure/{username}/administration/maintenance/dtr-rules';
export const YEAR_CLOSURE =
  'secure/admin/{username}/hours-management/year-closure';
export const DCC_OPTIONS =
  'secure/{username}/administration/duty-calculation-codes';
export const HOURS_CATEGORY = 'secure/users/{username}/group/hours-category';
export const DAY_CATEGORY = 'secure/users/{username}/group/day-category';
export const DISCONNECT_REASONS = 'secure/users/{username}/group/disconnect';
export const PREMIUM_PAYS =
  'secure/{username}/administration/maintenance/claBonus';
export const BONUS_TYPES = '/secure/users/{username}/group/bonus-type';
export const BONUS_25_METHOD = '/secure/users/{username}/group/bonus-25-method';
export const AUX_VALUE =
  'secure/{username}/administration/maintenance/auxValue';
export const AUX_VALUE_GROUP =
  'secure/{username}/administration/maintenance/auxValueGroup';
export const AUX_TRANSLATIONS =
  'secure/{username}/administration/maintenance/auxValueTranslation';
export const POOLS = 'secure/{username}/administration/maintenance/pools';
export const TRAVEL_COMPENSATION_TYPE =
  'secure/users/{username}/group/employee-travel-compensation-type';
export const ARRANGEMENTS =
  'secure/{username}/administration/maintenance/travel';
export const TRAVEL_LINES = `secure/{username}/administration/maintenance/travelLines`;
export const CREATE_ARRANGEMENT = `secure/travelsets/create/`;
export const COST_CENTERS = `secure/{username}/administration/maintenance/costcenters`; // ! Can be deleted if not used elsewhere
export const COST_CENTERS_BASE = `secure/public/costcenters`;
export const COST_CENTER_DETAILS = `secure/{username}/administration/maintenance/costcenterdetails`;
export const BASE_REPORTS = 'secure/users/{username}/reports/basic';
export const ADVANCED_REPORTS = 'secure/users/{username}/reports/advanced';
export const ADMIN_REPORTS = 'secure/users/{username}/reports/admin';
export const BALANCE_REPORTS = 'secure/users/{username}/reports/balance';
export const CONTRACTS = 'secure/users/{username}/group/contract-kind';
export const ACCOUNT_GROUPS =
  '/secure/{username}/administration/maintenance/account-groups';
export const GRANTS_CATALOG =
  'secure/{username}/administration/maintenance/grants-catalog';
export const GRANTS = 'secure/{username}/administration/maintenance/grants';
export const S3UPLOAD = 'secure/users/{username}/s3/upload-url';
export const SERVICE_DESK_REPORTS =
  'secure/users/{username}/reports/servicedesk';
export const SAVE_PWD_FOR_BI =
  'secure/{username}/administration/business-intelligence/password';
export const GET_USERNAME_FOR_BI =
  'secure/{username}/administration/business-intelligence/username';
export const ORGANIZATIONAL_UNIT_CHILDREN =
  'secure/organizational-unit-children';
export const ADMINISTRATION_ACCOUNTS =
  'secure/{username}/administration/maintenance/accounts';
export const ADMINISTRATION_EMPLOYEES =
  'secure/{username}/administration/maintenance/employees';
export const AFAS_IMPORT_MAPPING = `/secure/admin/{username}/imports/AFAS/entity-mappings`;
export const AFAS_CONNECTORS = `/secure/admin/{username}/imports/afas/connectors-config`;
export const IMPORT_EMPLOYEE_CONFIG = `/secure/{username}/administration/maintenance/importEmployeeConfig`;
export const IMPORT_EMPLOYEE_CONFIG_EMPLOYER = `/secure/{username}/administration/maintenance/importEmployeeConfigEmployer`;
export const TRAVEL_MOVEMENTS_EXPORT = `/secure/transportation-types/`;
export const TRAVEL_MOVEMENTS_EXPORT_SAVE = `/secure/transportation-types/update`;
export const ROSTER_COST_CENTER_DUTIES =
  'secure/users/{username}/roster/cost-centers/duties';
